import React from "react";

interface RestaurantConflictModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  currentRestaurantName?: string;
  newRestaurantName?: string;
}

const RestaurantConflictModal: React.FC<RestaurantConflictModalProps> = ({
  onConfirm,
  onCancel,
  currentRestaurantName = "another restaurant",
  newRestaurantName = "this restaurant",
}) => {
  return (
    <div>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-[1003] transition-colors duration-300"
        onClick={onCancel}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1004] pointer-events-none p-4">
        <div
          className="w-full max-w-[420px] p-6 rounded-[20px] bg-white dark:bg-gray-800 pointer-events-auto relative transition-colors duration-300 shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
              <svg
                className="w-8 h-8 text-orange-500 dark:text-orange-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-center text-[#050505] dark:text-white font-urbanist text-[20px] font-semibold leading-[140%] mb-3">
            Replace Cart Items?
          </h3>

          {/* Message */}
          <p className="text-center text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[15px] font-normal leading-[160%] mb-6">
            Your cart contains items from{" "}
            <span className="font-semibold text-[#7402A7] dark:text-purple-400">
              {currentRestaurantName}
            </span>
            . Do you want to discard the selection and add items from{" "}
            <span className="font-semibold text-[#7402A7] dark:text-purple-400">
              {newRestaurantName}
            </span>
            ?
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-6 py-3 rounded-[12px] border-2 border-[#7402A7] dark:border-purple-600 bg-transparent text-[#7402A7] dark:text-purple-400 font-urbanist text-[16px] font-semibold hover:bg-[#7402A7] hover:text-white dark:hover:bg-purple-600 dark:hover:text-white transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-6 py-3 rounded-[12px] bg-[#7402A7] dark:bg-purple-600 text-white font-urbanist text-[16px] font-semibold hover:bg-[#5f0289] dark:hover:bg-purple-700 transition-colors"
            >
              Yes, Replace
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantConflictModal;
